import { FaPhoneAlt, FaEnvelope } from "react-icons/fa"
import { Button } from "./parts"

const Contact = () => {
    const sendEmail = () => {
        const name = document.querySelector('#name').value
        const email = document.querySelector('#email').value
        const message = document.querySelector('#message').value

        window.location.href = `mailto:ap975527@gmail.com?subject=message from ${name} via website&body=name: ${name} \n email: ${email} \n\n ${message}`
    }
    
    return (
        <section id="contact" className="py-24 md:py-32 px-5 md:px-32">
            <div className="flex flex-col md:flex-row gap-16 items-center justify-center">
                <div className="flex-1">
                    <h1 className="text-4xl font-medium mb-3">Let's start <span className="text-primary">talking</span> with me</h1>
                    <p className="text-lg font-light text-gray-300">Please contact me via the form beside or the link below and get connected</p>
                    <div className="flex gap-11 mt-5">
                        <a href="tel:+6289637708786" className="text-primary flex gap-2 items-center"><FaPhoneAlt/>+6289637708786</a>
                        <a href="mailto:ap975527@gmail.com" className="text-primary flex gap-2 items-center"><FaEnvelope/>ap975527@gmail.com</a>
                    </div>
                </div>
                <div className="flex-1">
                    <form className="p-6 rounded shadow w-96 flex flex-col items-start">
                        <input type="text" name="name" id="name" placeholder="Name" className="w-full p-3 rounded bg-gray-100 focus:ring-2 focus:ring-gray-200 focus:outline-none mb-3" />
                        <input type="email" name="email" id="email" placeholder="Email" className="w-full p-3 rounded bg-gray-100 focus:ring-2 focus:ring-gray-200 focus:outline-none mb-3" />
                        <textarea name="message" id="message" rows="4" placeholder="Message" className="w-full p-3 rounded bg-gray-100 focus:ring-2 focus:ring-gray-200 focus:outline-none mb-3" />
                        <Button href="#contact" color="bg-primary" textColor="text-white" className="py-3" onClick={sendEmail}>Send message</Button>
                    </form>
                </div>
            </div>
        </section>
    )
}

export default Contact